export type AudienceMode = 'b2b' | 'b2c';

export interface AudienceDescriptor {
  badge: string;
  benefit: string;
  outcome: string;
}

export type AudienceCopy = Record<AudienceMode, AudienceDescriptor>;

export const AUDIENCE_COPY: AudienceCopy = {
  b2b: {
    badge: 'Performance Marketing Agencies',
    benefit: 'One login for every client’s campaigns, white-label reporting, CRM, and team access — no more juggling five separate tools per account.',
    outcome: 'Take on more clients without adding headcount, and protect margin on every retainer.',
  },
  b2c: {
    badge: 'Consumer & D2C',
    benefit: 'Personalized journeys, product analytics, conversational commerce, and flexible checkout orchestration.',
    outcome: 'Launch viral campaigns, grow loyal communities, and optimise LTV-to-CAC across every market.',
  },
};
